import { Component, OnInit, Inject } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';

@Component({
  selector: 'ebb-portal-dialog-confirm-delete',
  templateUrl: './dialog-confirm-delete.component.html',
  styles: []
})
export class DialogConfirmDeleteComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<DialogConfirmDeleteComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit() {
  }

  onClickYes(): void {
    this.dialogRef.close(true);
  }

  onClickNo(): void {
    this.dialogRef.close(false);
  }

}
